@if (!dropdownDesing) {
  <div class="tell-your-friends" [ngClass]="{ compacted: compacted }">
    <fa-icon *ngIf="compacted" class="share-icon" [icon]="shareIcon"></fa-icon>
    <span class="share-text" data-translate="public.commons.share" i18n="@@public.commons.share">Share</span>
    <ul class="social-links">
      <li *ngFor="let sl of socialLinks">
        <a [href]="onShareLink(sl)" (click)="onShareLinkClicked(sl, $event)" target="_blank">
          <fa-icon [icon]="sl.icon" size="lg"></fa-icon>
        </a>
      </li>
    </ul>
  </div>
} @else {
  <div class="social-links">
    <a class="social-links--button">
      <div class="social-links--button--wrapper">
        <fa-icon class="social-links--icon" [icon]="shareIcon" size="lg" />
      </div>
      <div class="social-links--dropdown">
        <ul class="social-links--list">
          @for (sl of socialLinks; track sl) {
            <li class="social-links--item">
              <a
                class="social-links--hyperlink"
                [href]="onShareLink(sl)"
                (click)="onShareLinkClicked(sl)"
                target="_blank"
              >
                <fa-icon [icon]="sl.icon" size="lg"></fa-icon>
              </a>
            </li>
          }
        </ul>
      </div>
    </a>
  </div>
}
